const CustomResourceApplyDX = () => import('@/views/main/report/customResourceApply/CustomResourceApplyDX.vue')
export default {
  path: '/main/report/customResourceApplyDX',
  name: 'customResourceApplyDX',
  component: CustomResourceApplyDX,
  children: []
}
